/**
 * @type {[{name: string, id: number},{name: string, id: number},{name: string, id: number},{name: string, id: number},{name: string, id: number},null,null,null,null,null,null,null,null,null,null,null]}
 */
export const channels = [
  {id: 1, name: 'Correo electrónico'},
  {id: 2, name: 'Página web'},
  {id: 3, name: 'Sucursal'},
  {id: 4, name: 'Telefono'},
  {id: 5, name: 'UNE'},
  {id: 6, name: 'CONDUSEF-SIGE gestión electrónica'},
  {id: 7, name: 'CONDUSEF-Gestión ordinaria'},
  {id: 8, name: 'Mensajeria'},
  {id: 9, name: 'Fax'},
  {id: 17, name: 'Oficinas de atención'},
  {id: 18, name: 'Centro de atención telefónica'},
  {id: 20, name: 'Aplicación móvil'},
  {id: 21, name: 'Interfaces'},
  {id: 22, name: 'Api\'s'},
  {id: 23, name: 'Bots'},
  {id: 25, name: 'Portal de queja electrónica FINTECH'},
];

/** @type {*[{id: number, name: string}]} */
export const attentionLevels = [
  {id: null, name: 'NA'},
  {id: 1, name: 'UNE'},
  {id: 2, name: 'Sucursal'},
  {id: 3, name: 'Centro de Atención Telefónica'},
  {id: 4, name: 'Oficinas de atención'},
];

export const pori = [
  {id: "SI", name: 'Sí'},
  {id: "NO", name: 'No'},
];

export const complaintStatus = [
  {id: 1, name: 'Pendiente'},
  {id: 2, name: 'Concluida'}
];

export const personTypes = [
  {id: 1, name: 'Física'},
  {id: 2, name: 'Moral'}
];

export const genders = [
  {id: "H", nombre: "Hombre"},
  {id: "M", nombre: "Mujer"},
];

export const penalties = [
  {id: null, name: 'No aplica'},
  {id: 1, name: 'Contractuales - Cancelación del contrato'},
  {id: 2, name: 'Contractuales - Reasignación de cartera'},
  {id: 3, name: 'Económicas - Multa'}
];

export const complaintAnswers = [
  {id: 1, name: 'Totalmente favorable al usuario'},
  {id: 2, name: 'Desfavorable al Usuario'},
  {id: 3, name: 'Parcialmente favorable al usuario'}
];